<mat-form-field appearance="outline" class="w-full !-mb-[1.25em]">
    @if (params.useSelectTypeahead) {
        <mat-select
            appSelectTypeahead
            matInput
            #inputElement
            tabindex="0"
            [formControl]="formControl"
            [placeholder]="params.placeholder ? params.placeholder : ''"
            [required]="params.required ? params.required : false"
            (selectionChange)="
                params.onSelectionChange
                    ? params.onSelectionChange(formControl)
                    : null
            "
        >
            @for (option of dropdownData; track option.value) {
                <mat-option [value]="option.value">{{
                    option.label
                }}</mat-option>
            }
        </mat-select>
    } @else {
        <mat-select
            matInput
            #inputElement
            tabindex="0"
            [formControl]="formControl"
            [placeholder]="params.placeholder ? params.placeholder : ''"
            [required]="params.required ? params.required : false"
            (selectionChange)="
                params.onSelectionChange
                    ? params.onSelectionChange(formControl)
                    : null
            "
        >
            @for (option of dropdownData; track option.value) {
                <mat-option [value]="option.value">{{
                    option.label
                }}</mat-option>
            }
        </mat-select>
    }
</mat-form-field>
